<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3>
                        <feather-icon icon-pack="feather-icon" icon="EditIcon"></feather-icon>
                        Update The User
                    </h3>
                </div>
                <div>
                    <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Update">
                        <tab-content title="Step 1" class="mb-5" icon="feather icon-user" :before-change="validateStep1">

                            <!-- tab 1 content -->
                            <form  @submit.prevent="validateStep1" data-vv-scope="step-1">
                                <div class="vx-row">
                                    <div class="vx-col w-1/2 mt-5">
                                        <vs-input data-vv-name="username" disabled label="Username" v-model="username" class="w-full" name="title" v-validate="'required'"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.username')">{{ errors.first('step-1.username') }}</span>
                                    </div>
                                    <div class="vx-col w-1/2 mt-5">
                                        <vs-input data-vv-name="company_name" label="Company Name" v-model="company_name" class="w-full" name="title" v-validate="'required'"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.company_name')">{{ errors.first('step-1.company_name') }}</span>
                                    </div>
                                    <div class="vx-col w-1/2 mt-5">
                                        <vs-input type="password" data-vv-name="password" label="New Password (Optional)" v-model="new_password" class="w-full" name="title" v-validate="'|min:6'"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.password')">{{ errors.first('step-1.password') }}</span>
                                    </div>
                                    <div class="vx-col w-1/2 mt-5">
                                        <vs-input type="password" data-vv-name="password_confirmation" label="New Password Confirmation (Optional)" v-model="new_password_confirmation" class="w-full" name="title" />
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.password_confirmation')">{{ errors.first('step-1.password_confirmation') }}</span>
                                    </div>
                                </div>
                            </form>
                        </tab-content>

                        <!-- tab 2 content -->
                        <tab-content title="Step 2" class="mb-5" icon="feather icon-radio" :before-change="validateStep2">
                            <form @submit.prevent="validateStep2" data-vv-scope="step-2">
                                <vs-row vs-w="12">
                                    <vs-col vs-w="4">
                                        <label>Form</label>
                                        <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required'" placeholder="Select From Date" v-model="from"></datepicker>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.from')">{{ errors.first('step-2.from') }}</span>
                                    </vs-col>
                                    <vs-col vs-w="4">
                                        <label>To</label>
                                        <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required'" placeholder="Select To Date" v-model="to"></datepicker>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.to')">{{ errors.first('step-2.to') }}</span>
                                    </vs-col>
                                    <vs-col vs-w="4">
                                        <div class="vx-row mb-6">
                                            <div class="vx-col w-full">
                                                <div style="margin-top: 11px;">
                                                    <span style="font-size: 13px;">Enable the user:</span>
                                                    <vs-switch val-icon-danger="warning" :danger="errors.has('status')" v-validate="'required'" style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="status">
                                                        <span slot="on">On</span>
                                                        <span slot="off">Off</span>
                                                    </vs-switch>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.status')">{{ errors.first('step-2.status') }}</span>
                                    </vs-col>
                                </vs-row>
                            </form>
                        </tab-content>

                        <!-- tab 3 content -->
                        <tab-content title="Step 3" class="mb-5" icon="feather icon-grid" :before-change="validateStep3">
                            <form @submit.prevent="validateStep3" data-vv-scope="step-3">
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5">
                                        <div class="centerx">
                                            <div class="flex justify-center">
                                                <vs-button @click.prevent="openInterfaceQuta=true" color="primary" type="border">Add New Quota</vs-button>
                                            </div>
                                            <vs-popup classContent="popup-example" title="Add New Interface" :active.sync="openInterfaceQuta">
                                                <vs-row vs-w="12">
                                                    <vs-col vs-w="12">
                                                        <vs-select v-model="selected_interfaces" width="100%" autocomplete placeholder="Select one or more" multiple class="selectExample" label="Interface(s)">
                                                            <vs-select-item :key="index" :value="item.title" :text="item.title" v-for="(item,index) in interfaces"/>
                                                        </vs-select>
                                                        <span class="text-danger text-sm" v-show="errors.has('interfaces')">{{ errors.first('selected_interfaces') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Total Requests Limitation</label>
                                                        <vs-input-number v-validate="'required|min:1'" v-model="input_total" icon-inc="expand_less" icon-dec="expand_more"/>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_total')">{{ errors.first('input_total') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Daily Requests Limitation</label>
                                                        <vs-input-number v-validate="'required|min:1'" v-model="input_daily" icon-inc="expand_less" icon-dec="expand_more"/>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_daily')">{{ errors.first('input_daily') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Date Form</label>
                                                        <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required|date_format:yyyy-MM-dd'" placeholder="Select From Date" v-model="input_date_from"></datepicker>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_date_from')">{{ errors.first('input_from') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Date To</label>
                                                        <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required|date_format:yyyy-MM-dd'" placeholder="Select To Date" v-model="input_date_to"></datepicker>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_date_to')">{{ errors.first('input_to') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Time From</label>
                                                        <flat-pickr class="vs-inputx vs-input--input normal" :config="configdateTimePicker" v-validate="'required'" v-model="input_time_from" placeholder="Choose time"/>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_time_from')">{{ errors.first('input_time_from') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <label>Time To</label>
                                                        <flat-pickr class="vs-inputx vs-input--input normal" :config="configdateTimePicker" v-validate="'required'" v-model="input_time_to" placeholder="Choose time"/>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_time_to')">{{ errors.first('input_time_to') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <div style="margin-top: 11px;">
                                                            <span style="font-size: 13px;">Enable:</span>
                                                            <vs-switch val-icon-danger="warning" :danger="errors.has('input_status')" v-validate="'required'" style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="input_status">
                                                                <span slot="on">On</span>
                                                                <span slot="off">Off</span>
                                                            </vs-switch>
                                                        </div>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_status')">{{ errors.first('input_status') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="6">
                                                        <div style="margin-top: 11px;">
                                                            <span style="font-size: 13px;">Encryption:</span>
                                                            <vs-switch val-icon-danger="warning" :danger="errors.has('input_encryption')" v-validate="'required'" style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="input_encryption">
                                                                <span slot="on">On</span>
                                                                <span slot="off">Off</span>
                                                            </vs-switch>
                                                        </div>
                                                        <span class="text-danger text-sm" v-show="errors.has('input_encryption')">{{ errors.first('input_encryption') }}</span>
                                                    </vs-col>
                                                    <vs-col vs-w="12">
                                                        <div class="flex justify-center mt-5">
                                                            <vs-button @click.prevent="addQuotas" color="primary" type="filled">Add</vs-button>
                                                        </div>
                                                    </vs-col>
                                                </vs-row>
                                            </vs-popup>
                                        </div>
                                    </div>
                                    <vs-row class="mt-2" vs-w="12">
                                        <vs-col v-for="(api,key) in apis" style="padding: 10px;" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                                            <vs-card>
                                                <div slot="header">
                                                    <h3>{{api.title}}</h3>
                                                </div>
                                                <div>
                                                    <vs-divider position="center">
                                                        Edit Info
                                                    </vs-divider>
                                                    <span>
                                                        <vs-row>
                                                                <vs-col vs-w="6">
                                                                    <label>Total Requests Limitation</label>
                                                                    <vs-input-number v-validate="'required|min:1'" v-model="api.total" icon-inc="expand_less" icon-dec="expand_more"/>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <label>Daily Requests Limitation</label>
                                                                    <vs-input-number v-validate="'required|min:1'" v-model="api.daily" icon-inc="expand_less" icon-dec="expand_more"/>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <label>Date Form</label>
                                                                    <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required|date_format:yyyy-MM-dd'" placeholder="Select From Date" v-model="api.date_from"></datepicker>
                                                                    <span class="text-danger text-sm" v-show="errors.has('input_date_from')">{{ errors.first('input_from') }}</span>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <label>Date To</label>
                                                                    <datepicker format="yyyy-MM-dd" class="w-full" v-validate="'required|date_format:yyyy-MM-dd'" placeholder="Select To Date" v-model="api.date_to"></datepicker>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <label>Time From</label>
                                                                    <flat-pickr class="vs-inputx vs-input--input normal" :config="configdateTimePicker" v-validate="'required'" v-model="api.time_from" placeholder="Choose time"/>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <label>Time To</label>
                                                                    <flat-pickr class="vs-inputx vs-input--input normal" :config="configdateTimePicker" v-validate="'required'" v-model="api.time_to" placeholder="Choose time"/>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <div style="margin-top: 11px;">
                                                                        <span style="font-size: 13px;">Enable:</span>
                                                                        <vs-switch val-icon-danger="warning" :danger="errors.has('input_status')" v-validate="'required'" style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="api.status">
                                                                            <span slot="on">On</span>
                                                                            <span slot="off">Off</span>
                                                                        </vs-switch>
                                                                    </div>
                                                                </vs-col>
                                                                <vs-col vs-w="6">
                                                                    <div style="margin-top: 11px;">
                                                                        <span style="font-size: 13px;">Encryption:</span>
                                                                        <vs-switch val-icon-danger="warning" :danger="errors.has('input_encryption')" v-validate="'required'" style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="api.encryption">
                                                                            <span slot="on">On</span>
                                                                            <span slot="off">Off</span>
                                                                        </vs-switch>
                                                                    </div>
                                                                </vs-col>
                                                        </vs-row>
                                                    </span>
                                                </div>
                                                <vs-divider position="center">
                                                    Summary
                                                </vs-divider>
                                                <vs-list style="text-align: left!important;">
                                                    <vs-list-item :title="'Total Requests: '+ api.total"></vs-list-item>
                                                    <vs-list-item :title="'Daily Requests: '+ api.daily"></vs-list-item>
                                                    <vs-list-item :title="'Date From: '+ api.date_from"></vs-list-item>
                                                    <vs-list-item :title="'Date To: '+ api.date_to"></vs-list-item>
                                                    <vs-list-item :title="'Time From: '+ api.time_from"></vs-list-item>
                                                    <vs-list-item :title="'Time To: '+ api.time_to"></vs-list-item>
                                                    <vs-list-item :title="'Enabled: '+(api.status ? 'Yes' : 'No')"></vs-list-item>
                                                    <vs-list-item :title="'Encryption: '+( api.encryption ? 'Yes' : 'No' )"></vs-list-item>
                                                </vs-list>
                                                <div slot="footer">
                                                    <vs-row vs-justify="flex-end">
                                                        <vs-button @click.prevent="removeQuota(key)" color="danger">Remove</vs-button>
                                                    </vs-row>
                                                </div>
                                            </vs-card>
                                        </vs-col>
                                    </vs-row>

                                </div>
                            </form>
                        </tab-content>
                    </form-wizard>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>


<script>

    import Configs from '../../config.js';
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import Datepicker from 'vuejs-datepicker';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import loadsh from 'lodash/lodash';

    export default {
        data() {
            return {
                configdateTimePicker: {
                    enableTime: true,
                    enableSeconds: false,
                    noCalendar: true
                },
                id: null,
                input_total: 100,
                input_daily: 10,
                input_date_from: null,
                input_date_to: null,
                input_time_from: null,
                input_time_to: null,
                input_status: true,
                input_encryption: false,
                selected_interfaces: [],
                interfaces: [],
                openInterfaceQuta: false,
                username: null,
                new_password: null,
                new_password_confirmation: null,
                company_name: null,
                from: null,
                to: null,
                status: true,
                apis: []
            }
        },
        components: {
            FormWizard,
            TabContent,
            Datepicker,
            flatPickr
        },
        created() {
            this.setSavedData();
            this.setBreadCrumbsItems();
            this.getInterfaces();
        },
        watch: {
            apis: function () {
                this.getInterfaces();
            }
        },
        methods: {
            setSavedData() {
                let data = JSON.parse(localStorage.getItem('saved_object'));
                if (data) {
                    this.id = data.id;
                }

                this.$vs.loading();

                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/users/get-user',
                    data: {id:this.id},
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    console.log(response);
                    this.username = response.data.user.username;
                    this.company_name = response.data.user.company_name;
                    this.from = response.data.user.from;
                    this.to = response.data.user.to;
                    this.status = response.data.user.status;
                    this.apis = response.data.apis;
                    this.$vs.loading.close();
                }).catch((err) => {
                    console.log(err.response);
                    this.$vs.loading.close();
                })
            },
            updateInterfaces() {
                this.interfaces = _.differenceBy(this.interfaces, this.apis, 'title');
            },
            removeQuota(key) {
                this.apis = _.filter(this.apis, function (o, i) {
                    return (i !== key);
                });
                let obj = _.filter(this.apis, function (o, i) {
                    return (i === key);
                });
                console.log(obj);
                if (obj.length > 0) {
                    console.log(obj[0]);
                    vm.interfaces.push(obj[0]);
                }
            },
            addQuotas() {
                let vm = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (vm.selected_interfaces.length <= 0) {
                            this.$vs.notify({title: 'Warning', text: 'The interface(s) is required', color: 'danger', iconPack: 'feather', icon: 'icon-info'});
                            return 0;
                        }
                        vm.selected_interfaces.forEach(function (interface_title, index) {
                            vm.apis.push({
                                title: interface_title,
                                total: vm.input_total,
                                daily: vm.input_daily,
                                date_from: vm.input_date_from,
                                date_to: vm.input_date_to,
                                time_from: vm.input_time_from,
                                time_to: vm.input_time_to,
                                status: vm.input_status,
                                encryption: vm.input_encryption
                            });
                        });
                        this.selected_interfaces = [];
                        this.input_total = 100;
                        this.input_daily = 10;
                        this.input_date_from = null;
                        this.input_date_to = null;
                        this.input_time_from = null;
                        this.input_time_to = null;
                        this.input_status = true;
                        this.input_encryption = false;
                        this.openInterfaceQuta = false;
                    }
                });
            },
            getInterfaces() {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/users/get-interfaces',
                    data: {},
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.interfaces = response.data;
                    this.loader = false;
                    this.updateInterfaces();
                }).catch((err) => {
                    console.log(err.response);
                    this.loader = false;
                })
            },
            submit() {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/users/update',
                    data: this.$data,
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.$vs.notify({title: 'Great', text: 'You successfully updated the user', color: 'success', iconPack: 'feather', icon: 'icon-check'});
                    this.$router.push({name: 'users-show'});
                }).catch((err) => {
                    this.$setLaravelValidationErrorsFromResponse(err.response.data);
                    this.loader = false;
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Users',
                        url: '/Users/show'
                    },
                    {
                        title: 'Update a user',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            },
            validateStep1() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll('step-1').then(result => {
                        if (result) {
                            resolve(true)
                        } else {
                            reject("correct all values");
                        }
                    })
                })
            },
            validateStep2() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll("step-2").then(result => {
                        if (result) {
                            resolve(true)
                        } else {
                            reject("correct all values");
                        }
                    })
                })
            },
            validateStep3() {
                this.submit();
            }
        }
    }
</script>

<style>
    .pagination-bar {
        display: none;
    }

    .options {
        margin: 1px !important;
        display: inline-flex !important;
    }

    .vdp-datepicker input {
        width: 100%;
    }
</style>